export default "__VITE_ASSET__BTa93nwr__"